import _isEmpty from 'lodash/isEmpty'

import {
  AUTH_CALLBACK_ACCESS_DENIED_ERROR,
  AUTH_CALLBACK_ERROR_DESCRIPTION_PARAM,
  AUTH_CALLBACK_ERROR_PARAM,
} from './page.constants'

const AUTH_ERROR_DESCRIPTION_MESSAGES: Record<string, string> = {
  'no database users match this email':
    'We could not find an account for that email. Please contact support.',
  'no database users match this phone number':
    'We could not find an account for that phone number. Please contact support.',
}

const DEFAULT_ACCESS_DENIED_MESSAGE =
  'We could not sign you in with those credentials. Please contact support.'

export function normalizeAuthCallbackErrorDescription(errorDescription: string): string {
  return errorDescription.trim().toLowerCase()
}

export function getAuthCallbackErrorMessage(
  error: string | null,
  errorDescription: string | null
): string | null {
  if (error !== AUTH_CALLBACK_ACCESS_DENIED_ERROR) {
    return null
  }

  const normalizedDescription = normalizeAuthCallbackErrorDescription(errorDescription ?? '')
  if (_isEmpty(normalizedDescription)) {
    return DEFAULT_ACCESS_DENIED_MESSAGE
  }

  return (
    AUTH_ERROR_DESCRIPTION_MESSAGES[normalizedDescription] ?? DEFAULT_ACCESS_DENIED_MESSAGE
  )
}

export function readAuthCallbackErrorFromSearch(search: string): string | null {
  const params = new URLSearchParams(search)

  return getAuthCallbackErrorMessage(
    params.get(AUTH_CALLBACK_ERROR_PARAM),
    params.get(AUTH_CALLBACK_ERROR_DESCRIPTION_PARAM)
  )
}

export function clearAuthCallbackErrorParams(): void {
  if (typeof window === 'undefined') {
    return
  }

  const params = new URLSearchParams(window.location.search)
  params.delete(AUTH_CALLBACK_ERROR_PARAM)
  params.delete(AUTH_CALLBACK_ERROR_DESCRIPTION_PARAM)

  const newSearch = params.toString()
  const newPath = newSearch
    ? `${window.location.pathname}?${newSearch}`
    : window.location.pathname

  window.history.replaceState(null, '', newPath)
}
